<script>
import { addNewWhatDo } from '@/services/WhatDoServices';
export default {
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      // 
      newWheelTitle: '',
      newWheelDescription: '',
      // 
      newProjects: [],
      // {title, tagline, weight}
      newProjectTitle: '',
      newProjectTagline: '',
      newProjectWeight: 2,
      weightOptions: [
        { display: 'Low Priority', value: 1},
        { display: 'Normal', value: 2},
        { display: 'High Priority', value: 3},
      ],
    };
  },
  computed: {
    allowAddNewProject() {
      return this.newProjectTitle.trim().length && this.newProjectTagline.trim().length;
    },
    allowCreateNewWhatDo() {
      return this.newWheelTitle.trim().length && this.newProjects.length;
    },
  },
  methods: {
    addNewProjectToWhatDo() {
      console.log('starting addNewProjectToWhatDo() ***');

      // add project to this whatDo wheel
      this.newProjects.push({
        title: this.newProjectTitle.trim(),
        tagline: this.newProjectTagline.trim(),
        weight: parseInt(this.newProjectWeight),
      });

      // reset "add a project" section/fields
      this.newProjectTitle = '';
      this.newProjectTagline = '';
      this.newProjectWeight = 2;
      // "focus" on newProjectTitle
      const pt = document.getElementById('new-project-title');
      if (pt) { pt.focus(); }
    },
    removeProjectFromWhatDo(index) {
      this.newProjects.splice(index, 1);
    },
    async createNewWhatDo() {
      const newWhatDo = {
        title: this.newWheelTitle,
        description: this.newWheelDescription,
        projects: this.newProjects,
      };
      console.log('*** starting createNewWhatDo() ***', newWhatDo);

      const newWhatDoWasCreated = await addNewWhatDo(this.uId, this.token, newWhatDo);
      if (newWhatDoWasCreated) {
        this.$router.push('/whatdo');
      }

    }
  },
  created() {
    console.clear();
  },
}
</script>

<template>
<div id="page-whatdo-new" class="pt-4 pb-16 px-2">

  <!-- PAGE HEADER -->
  <div id="whatdo-new-page-header" class="px-4">
    <h1 class="mb-4 text-center">Create a new <br />whatDo wheel</h1>

    <p class="my-2 text-body-2 font-italic">
      No more thumb-twiddling. Spin the wheel to randomly select what to work on — <b>whatDo</b>.
    </p>
    <p class="my-2 text-body-2 font-italic"><b>if the whatDo wheel lands on something, but in your heart you want to work on another thing?</b> <u><i>Good</i>.</u> Do that. Do It To It. <u>NOW</u>.</p>
    <p></p>
  </div>


  <!-- WHEEL METADATA -->
  <div id="new-metadata" class="mt-12 mb-8">
    <v-text-field v-model="newWheelTitle"
                  label="Wheel Title"
                  placeholder="Enter the name of this whatDo wheel"
                  variant="outlined"
                  clearable
    ></v-text-field>

    <v-textarea v-model="newWheelDescription"
                label="Wheel Description"
                placeholder="Enter a short description of what this whatDo wheel is for"
                variant="outlined"
                rows="2"
                auto-grow
                clearable
    ></v-textarea>
  </div>


  <!-- PROJECTS -->
  <div class="my-8">
    <h3 class="text-center text-capitalize"><b><u>Projects in this whatDo wheel</u></b></h3>


    <!-- display this wheel's projects -->
    <div v-if="newProjects.length" class="my-2 pa-4 border">
      <ol class="ml-4">
        <li v-for="(p, i) in newProjects" :key="i">
          <p><b>Title:</b> <u class="text-capitalize">{{ p.title }}</u></p>
          <p><b>Tagline:</b> {{ p.tagline }}</p>
          <p><b>Importance:</b> {{ weightOptions[parseInt(p.weight)-1].display }}</p>
          <p class="remove-one-project text-right text-body-2 text-red-lighten-2" @click.prevent="removeProjectFromWhatDo(i)"><i>Remove this project</i></p>
          <hr v-if="i !== newProjects.length - 1" class="my-3 text-black" />
        </li>
      </ol>
    </div>

    
    <!-- add a new project -->
    <v-expansion-panels class="mt-8" >
      <v-expansion-panel>
        <v-expansion-panel-title color="blue-lighten-3">
          <b>+ Add a Project to this whatDo Wheel</b>
        </v-expansion-panel-title>
        <v-expansion-panel-text class="py-4">
          <v-text-field v-model="newProjectTitle"
                        id="new-project-title"
                        label="Project Title"
                        placeholder="Enter a new project title"
                        variant="outlined"
                        clearable
          ></v-text-field>
          <v-textarea v-model="newProjectTagline"
                      label="Project Tagline"
                      placeholder="Enter a brief description of this project"
                      variant="outlined"
                      rows="2"
                      auto-grow
                      clearable
          ></v-textarea>
          <v-select v-model="newProjectWeight"
                    :items="weightOptions"
                    item-title="display"
                    item-value="value"
                    label="Weight/Importance"
                    variant="outlined"
          ></v-select>
          <div class="mt-2 d-flex flex-column align-end">
            <v-btn @click.prevent="addNewProjectToWhatDo"
                   :color="allowAddNewProject ? 'blue-lighten-2' : 'grey-lighten-5'"
                   :disabled="!allowAddNewProject"
                   class="text-capitalize"
                   density="comfortable"
            >Add Project</v-btn>
            <p class="mt-2 text-body-2 text-end">this adds a new slice<br /> to the whatDo wheel</p>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    
  </div>


  <!-- SAVE BUTTON -->
  <div class="my-12 d-flex flex-column align-center">
    <v-btn @click.prevent="createNewWhatDo"
           class="mt-12"
           :color="allowCreateNewWhatDo ? 'green-lighten-1' : 'grey-lighten-5'"
           :disabled="!allowCreateNewWhatDo"
    >Save New WhatDo</v-btn>
    <p v-if="allowCreateNewWhatDo" class="mt-2 mb-12 text-center text-body-2">this creates a new whatDo wheel</p>
  </div>


</div>
</template>

<style scoped lang="scss">
#page-whatdo-new {
  max-width: 700px;
  margin: 0 auto;

  .remove-one-project:hover {
    cursor: pointer;
  }


}
</style>
